export default __webpack_public_path__ + "static/media/SEASON_CARD_IN_PLASTIC_PROTECTOR_.12e6a4b2.png";